import { render } from "./CoursesRecord.vue?vue&type=template&id=0f3bbb3a&scoped=true"
import script from "./CoursesRecord.vue?vue&type=script&lang=js"
export * from "./CoursesRecord.vue?vue&type=script&lang=js"

import "./CoursesRecord.vue?vue&type=style&index=0&id=0f3bbb3a&scoped=true&lang=css"
import "./CoursesRecord.vue?vue&type=style&index=1&id=0f3bbb3a&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3bbb3a"]])

export default __exports__